export function getVideoConstraints(options) {
  const { videoOptions, videoQuality } = options || {};
  const videoConstraints = {
    LOW: {
      id: "LOW",
      constraints: {
        audio: false,
        video: {
          frameRate: { ideal: 15 },
          width: { ideal: 320 },
          height: { ideal: 180 },
          ...videoOptions
        }
      }
    },

    MEDIUM: {
      id: "MEDIUM",
      constraints: {
        audio: false,
        video: {
          frameRate: { ideal: 20 },
          width: { ideal: 640 },
          height: { ideal: 360 },
          ...videoOptions
        }
      }
    },
    HIGH: {
      id: "HIGH",
      constraints: {
        audio: false,
        video: {
          frameRate: { ideal: 20 },
          width: { ideal: 1280 },
          height: { ideal: 720 },
          ...videoOptions
        }
      }
    },
    UNKNOWN: {
      id: "UNKNOWN",
      constraints: {
        audio: false,
        video: {
          frameRate: { ideal: 20 },
          width: { ideal: 1280 },
          height: { ideal: 720 },
          ...videoOptions
        }
      }
    }
  };
  return videoConstraints[videoQuality] || videoConstraints;
}

export function getAudioConstraints(options) {
  const { audioOptions } = options || {};
  return {
    audio: {
      channelCount: { exact: 1 },
      echoCancellation: true,
      noiseSuppression: true,
      sampleRate: 16000,
      ...audioOptions
    },
    video: false
  };
}
